import { render, staticRenderFns } from "./AddUpdateArchive.vue?vue&type=template&id=676513bc&scoped=true&"
import script from "./AddUpdateArchive.vue?vue&type=script&lang=js&"
export * from "./AddUpdateArchive.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdateArchive.vue?vue&type=style&index=0&id=676513bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676513bc",
  null
  
)

export default component.exports